import { React } from "react";
import Sidebar from "../../Components/Sidebar/sidebar";
import { Layout } from "antd";
import { Routes, Route } from "react-router-dom";
import HeaderNav from "../../Components/Header/Header";
import ProfileViewData from "../ProfileSettings/GeneralSetting/viewProfile";
import ProfileEditData from "../ProfileSettings/GeneralSetting/editProfile";
import ProfilePasswordData from "../ProfileSettings/PasswordSetting/password";
const { Content } = Layout;

const ProfileSetting = (props) => {

  const listItems =
    [
          {
            icon: "user",
            label: "General",
            link: "general",
          },
          {
            icon: "relock",
            label: "Password",
            link: "change-password",
          },
     ];

  return (
    <Layout>
      <HeaderNav />
      <Layout>
        <Sidebar headerName="Profile Settings" listItems={listItems} />
        <Layout>
          <Content>
            <Routes>
              <Route path="/general" element={<ProfileViewData/>}/>
              <Route path="/general-edit" element={<ProfileEditData/>}/>
              <Route path="/change-password" element={<ProfilePasswordData/>}/>
            </Routes>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ProfileSetting;
